import PropTypes from "prop-types";
import ProductPrice from "../../../block-elements/product-price/product-price";
import ExpandContent from "../../../block-elements/expand-content/expand-content";

const ProductInfo = (props) => {
  const styles = props.styles;

  return (
    <div className="block--max-width-narrow">
      <div className={styles.info}>
        <h1 className={styles.productName}>{props.productName}</h1>
        <ProductPrice
          price={props.baseProduct.price}
          previousPrice={props.baseProduct.previousPrice}
          currencyDisplayName={props.currencyDisplayName}
          priceClassName="h4"
          customPriceText={props.customPriceText}
          ignoreComponentTheme={true}
        />
        <div dangerouslySetInnerHTML={{ __html: props.description }}></div>
        {props.readMoreBody && (
          <div className={styles.readMoreWrapper}>
            <ExpandContent expandLabel={props.readMoreLabel ? props.readMoreLabel : undefined}>
              <div dangerouslySetInnerHTML={{ __html: props.readMoreBody }} className={styles.readMoreWrapper}></div>
            </ExpandContent>
          </div>
        )}
        {!props.hasJetshop && props.customCtaText && <h5>{props.customCtaText}</h5>}
      </div>
    </div>
  );
};

ProductInfo.propTypes = {
  styles: PropTypes.object,
  productName: PropTypes.string,
  baseProduct: PropTypes.object,
  currencyDisplayName: PropTypes.string,
  customPriceText: PropTypes.string,
  description: PropTypes.string,
  readMoreLabel: PropTypes.string,
  readMoreBody: PropTypes.string,
  customCtaText: PropTypes.string,
  hasJetshop: PropTypes.bool,
};

export default ProductInfo;
